const analyticsEvents = {
  pageView: 'pageView',
  firstTimeVisit: 'First time visit',
  clickUpgrade: 'click on upgrade',
  clickDowngrade: 'click on downgrade',
  clickLogin: 'click on login',
  loginSuccess: 'Login',
  clickCreateAccount: 'click on Create account',
  logout: 'Logout',
  clickUserMenu: 'click on user menu',
  clickPricing: 'click on pricing',
  subscribeClicked: 'subscribe clicked',
  clickStartFreeTrial: 'click on start free trial',
  clickStartWithPlan: 'click on start with',
  createTeamStep1: 'Click on create a team - step 1',
  createTeamStep2: 'Continue to create a team step 2',
  register: 'register',
  registrationFailed: 'registration failed',
  loginFailed: 'login failed',
  clickOnSocialRegister: 'click on social register',
  clickOnSocialLogin:'click on social login',
  myAccountArea: {
    menuOpened: 'menu opened',
    menuItemChosen: 'menu item chosen',
    tabSelected: 'tab selected',
    uploadButtonClicked: 'upload button clicked',
    myAccountUploadSaveButtonClicked: 'my account upload save button clicked',
    myAccountUploadCancelButtonClicked: 'my account upload cancel button clicked',
    shareButtonClicked: 'share button clicked',
    shareMethodChosen: 'share method chosen',
    createATeam: 'create a team',
    loggedOut: 'logged out',
  },
  clickOnContinueToBrowse: 'click on continue browse',
  clickOnGetALicense: 'click on get a license',
  clickOnCategory: 'click on category',
  signUpPopupOpened: 'sign up popup opened',
  signInPopupOpened: 'sign in popup opened',
  signupButtonClicked: 'signup button clicked',
  closeButtonClicked: 'close button clicked',
  navigationClick: 'navigationClick',
  cookieAccepted: 'cookie accepted',
};

export default analyticsEvents;
